import { render, staticRenderFns } from "./activityDownloadPage.vue?vue&type=template&id=fd9905b2"
import script from "./activityDownloadPage.vue?vue&type=script&lang=js"
export * from "./activityDownloadPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports